import React from 'react';
import { useTranslation } from 'react-i18next';
import { EventIcon, StarIcon, ChartIcon, MapIcon, ListIcon } from './icons/NavIcons';

/**
 * Composant affichant les avantages de l'utilisation des crédits
 * Utilisé dans CreateEventPage et CreditRechargePage
 */
const CreditBenefitsInfo = () => {
  const { t } = useTranslation();

  const benefits = [
    {
      icon: EventIcon,
      title: t('credits.benefits.createEvent.title'),
      description: t('credits.benefits.createEvent.description')
    },
    {
      icon: StarIcon,
      title: t('credits.benefits.featured.title'),
      description: t('credits.benefits.featured.description')
    },
    {
      icon: ChartIcon,
      title: t('credits.benefits.stats.title'),
      description: t('credits.benefits.stats.description')
    }
  ];

  return (
    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg shadow-sm p-6 mb-6 border border-blue-100">
      <p className="text-sm text-gray-700 text-center mb-4 font-medium">
        {t('credits.recharge.info')}
      </p>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {benefits.map((benefit, index) => {
          const IconComponent = benefit.icon;
          return (
            <div 
              key={index}
              className="bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="flex justify-center mb-2">
                <IconComponent className="w-8 h-8 text-bleu1" />
              </div>
              <h3 className="text-sm font-semibold text-gray-800 text-center mb-1">
                {benefit.title}
              </h3>
              <p className="text-xs text-gray-600 text-center">
                {benefit.description}
              </p>
            </div>
          );
        })}
      </div>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg p-4 shadow-sm">
          <div className="flex items-center justify-center gap-2 mb-3">
            <MapIcon className="w-5 h-5 text-gray-400" />
            <h4 className="text-sm font-semibold text-gray-800">
              {t('credits.benefits.featured.mapView')}
            </h4>
          </div>
          <img 
            src="/carte_mis_en_avant.gif" 
            alt={t('credits.benefits.featured.mapView')}
            className="w-full rounded-lg border border-gray-200"
          />
        </div>
        <div className="bg-white rounded-lg p-4 shadow-sm">
          <div className="flex items-center justify-center gap-2 mb-3">
            <ListIcon className="w-5 h-5 text-gray-400" />
            <h4 className="text-sm font-semibold text-gray-800">
              {t('credits.benefits.featured.listView')}
            </h4>
          </div>
          <img 
            src="/liste_mis_en_avant.gif" 
            alt={t('credits.benefits.featured.listView')}
            className="w-full rounded-lg border border-gray-200"
          />
        </div>
      </div>
    </div>
  );
};

export default CreditBenefitsInfo;
